import styles from './InputAutocomplete.module.css';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function InputAutocomplete({
  name,
  label,
  value,                 // <- string
  onChange,              // <- handleInputChange(e)
  options,               // <- [{ value:'CA', label:'California' }, ...]
  error,
  onFocus,
  onBlur,
  placeholder
}) {

  const selectedOption = options.find(o => o.value === value) || null;

  const emitChange = (newVal) => {
    const syntheticEvent = {
      target: {
        name,
        value: newVal ? newVal.value : ''
      }
    };
    onChange?.(syntheticEvent);
  };

  const emitFocus = () => onFocus?.({ target: { name } });
  const emitBlur  = () => onBlur?.({ target: { name } });

  return (
    <div className={styles.inputContainer}>
        {label && <label className={styles.label}>{label}</label>}
        <Autocomplete
            value={selectedOption}
            className={styles.autoRoot}
            options={options}
            fullWidth
            autoHighlight
            disablePortal
            isOptionEqualToValue={(opt, val) => opt.value === val.value}
            getOptionLabel={(opt) => opt?.label ?? ''}
            onChange={(_, newVal) => emitChange(newVal)}
            onFocus={emitFocus}
            onBlur={emitBlur}
            sx={{
              '& .MuiInputBase-root': {padding: '8.25px 18px'},
              '& .MuiOutlinedInput-notchedOutline': { border: '1px solid #CBCBCBFD', transition: 'border-color 0.3s' },
              '&:hover .MuiOutlinedInput-notchedOutline': { border: '1px solid #CBCBCBFD', transition: 'border-color 0.3s' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: '1px solid #1976d2' },

            }}
            renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={placeholder || 'Select'}
                  inputProps={{ ...params.inputProps, name }}
                  sx={{
                    '& .MuiAutocomplete-input': {
                      padding: '0 !important',
                      fontFamily: "inherit !important",
                      fontSize: '18px !important'
                    },
                  }}
                />
            )}
        />
        {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
}
